<template>
    <div> 
        <v-layout  >
            <v-col md="3" sm="12" class="pr-0" v-if="false">
                <v-card :height="vsh+10" tile> 
                    <v-card-title class="primary  pt-2  pb-2">
                        <div class="font-weight-bold b2--text"> 
                                <span >{{ThisOutlet?.name}}</span>  
                            </div> 
                        <v-layout justify-center align-center class="mb-0"> 
                            <v-autocomplete  class="ml-2 mt-1 pb-0" dark  
                                :label="'Select device'" 
                                prepend-inner-icon="mdi-cash-register" 
                                clearable 
                                filled
                                rounded
                                :items="[]"
                                :item-text="'name'"
                                item-value="key"
                                outlined
                                ></v-autocomplete> 
                            <v-menu bottom left  rounded="xl" >
                                <template v-slot:activator="{ on }">
                                <v-btn class="ml-2"
                                    dark
                                    icon
                                    v-on="on" >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                                </template> 
                                <v-card>
                                    <v-card-title class="secondary white--text not-f4" >
                                        SELECT ACTION
                                    </v-card-title> 
                                    <v-list  > 
                                        <div v-for="(item, index) in ActionItems" :key="index">
                                            <v-list-item  @click="TABLE_ACTION(item.action,item)" >
                                                <v-list-item-action class="mr-3" ><v-icon>{{item.icon}}</v-icon></v-list-item-action>
                                                <v-list-item-title class="">{{item.text}}</v-list-item-title>
                                            </v-list-item> 
                                        </div>
                                            
                                    </v-list> 
                                </v-card>
                            </v-menu>
                        </v-layout>
                    </v-card-title>
                    <v-card-text class="p-0">
                        <v-timeline
                            align-top
                            dense 
                            
                            >
                            <v-timeline-item v-for="(item, index) in DELIVER_OPTION" :key="index" 
                                color="primary"
                                outlined fill-dot
                                :icon="item.icon"
                                >
                                <v-row class="pt-1">
                                    
                                    <v-col>
                                        <strong>{{item.name}}</strong>
                                        <div class="text-caption">
                                            {{item.description}}
                                        </div>
                                    </v-col>

                                    <v-col cols="3">
                                        <v-layout  align-center justify-center> 
                                            <v-icon color="secondary">mdi-circle-medium</v-icon>
                                            <strong class="not-f6">{{item.number}}</strong>
                                        </v-layout>
                                    </v-col>
                                </v-row>
                            </v-timeline-item> 
                        </v-timeline>
                    </v-card-text>
                    <mbs-actions-field v-if="false"  class="my-1" 
                        :items="ActionItems"
                        :data="WarehouseSession"
                        @ITEM_ACTION="ITEM_ACTION"
                        />    
                </v-card> 
            </v-col>

            <v-col md="12" sm="12" cols="12">  
                <v-card :min-height="vsh/2" > 
                    <v-card>
                        <mbs-page-tab 
                            v-model="warehouse_current_page"
                            :items="PAGE_TABS"/>   
                    </v-card>  
                    <mbs-item-manager :height="vsh-250"
                        :table_title="ThisOutlet?.name"
                        :table_title_icon="'mdi-warehouse'"
                        v-model="input"
                        :row_click="true"
                        :show_select="true"
                        :row_click_action="true" 
                        :table_tabs="TABLE_TABS"
                        :add_vertical_lines="true"
                        :top_label="false" 
                        :fixed_header="true" 
                        
                        :filter_date_value="''"
                        :filter_default_days="'1'"
                        :filters="FILTERS"
                        :name_items="'.....'"
                        :name_item="NAME_ITEM+'--'"
                        :value_items="VALUE_ITEMS"
                        :value_item="VALUE_ITEM"
                        :field_items="DATA.FIELDS.items"
                        :header_items="HEADER_ITEMS"
                        :header_items2="HEADER_ITEMS2"
                        :data_items="TableData"  
                        :is_joined="true"  
                        :path_item="PATH_ITEM"  
                        :select_items="Selectors"  
                        :total_item_values="TOTAL_ITEM_VALUES"  

                        :table_actions="TABLE_ACTIONS" 
                        @SELECT_TABLE_ACTION="TABLE_ACTION"
                        @SELECT_ITEM_ACTION="ITEM_ACTION"
                        @apply="APPLY_DAYSHIFTS($event,true)"
                    />  
                </v-card>
                
            </v-col>  
        </v-layout>
        

        <!-- //DIALOGS -->
        <div>
            <div v-if="ADDING_ITEM">
                <mbs-item-manager 
                    :show="false" 
                    :add_item_action="ADDING_ITEM.add_item_action"
                    :name_items="ADDING_ITEM.names"
                    :name_item="ADDING_ITEM.name"
                    :value_items="ADDING_ITEM.values"
                    :value_item="ADDING_ITEM.value"
                    :field_items="ADDING_ITEM.fields"   
                    :path_item="ADDING_ITEM.path"  
                    :select_items="Selectors"  
                    @ADDED="ADDED" 
                /> 
            </div>

           <!-- <mbs-stock-transfer 
                :from_outlet_code="stock_outlet_code"
           /> <mbs-stock-receive 
                :to_outlet_code="stock_outlet_code"
           />  -->

           <mbs-stock-inventory 
                :to_outlet_code="stock_outlet_code"
                :from_outlet_code="stock_outlet_code"
           /> 

           <div v-if="dialog_doc_show"> 
                <mbs-dialog-doc-show
                    v-model="dialog_doc_show" 
                    :title="input_show_doc.title"
                    :data="input_show_doc.data"
                    :data_key="input_show_doc.data_key"
                    :document_type="input_show_doc.document_type"
                    :height="input_show_doc.height"
                    :top_header="input_show_doc.top_header"
                    :bottom_header="input_show_doc.bottom_header"
                />  
            </div>

            <!-- View SAGE TRANSFER ORDERS DIALOG -->
            <v-dialog
                v-model="dialog_view_sage_transfer_orders"
                scrollable   
                :persistent="false" :overlay="false"
                max-width="900px"
                transition="dialog-transition" > 
                <v-card rounded="lg" v-if="dialog_view_sage_transfer_orders" > 
                    <v-card-title class="primary">
                        <div class="font-weight-bold b2--text"> 
                            <span >SAGE TRANSFER ORDER(S)</span> 
                        </div> 
                        <v-badge  class="mr-2"   :value="SHOW_OFFLINE" 
                            bordered
                            :class="MBS.data.animate.zoom.in"
                            :color="onlineIndicator" dot
                            overlap
                        >  
                            <v-icon dark>{{"mdi-download-network-outline"}}</v-icon>
                        </v-badge>
                        <v-spacer></v-spacer>   
                        <v-btn :loading="SageLoader('sage_invoice')?.loading" tile small color="secondary" @click="REFRESH_ORDERS('sage_inventory_transfer','Sage Inventory Transfers')">
                             
                            Refresh
                            <v-icon class="ml-2" >mdi-refresh</v-icon>
                        </v-btn>   
                    </v-card-title>
                    <!-- <mbs-page-tab
                        v-model="currentItemOrderTab"
                        color="b2" 
                        text_color="black" dark
                        :items="TabOderItems"
                        @on_changed="CHANGED_ITEM_ORDER_TAB"/>  -->
                    <v-card-text> 
                        <v-card-title>
                            <v-checkbox @click="ON_SELECT_SAGE_ALL_TRANSFERS(input_select_sage_invoices)" :inset="false"    style="margin: 5px; margin-left: -1px;"
                                v-model="input_select_sage_invoices"
                                label="SELECT TRANSFERS"   hide-details
                                class="ml-1"
                            ></v-checkbox> 
                            <!-- TRANSFERS -->
                            <v-spacer></v-spacer> 
                            <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line dense
                                clearable
                                hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-card outlined class="mbs-scroll-y"  :height="vsh-330"> 
                            <v-list v-if="MBS.actions.SIZE(SageTransferOrdersSearch)!=0" class=""
                                :bench="2"
                                :items="SageTransferOrdersSearch" 
                                item-height="70" >
                                <!-- <template v-slot="{ item,index }"> -->
                                <template v-for="(item,index) in SageTransferOrdersSearch"> 
                                    <v-list-item :disabled="(item.processed && item.processed!='No')" @click="ON_SUBMIT_SAGE_TRANSFER_ORDER(item,index)" :key="index"> 
                                        <v-list-item-action>  
                                            <v-layout row wrap> 
                                                <v-avatar v-if="MBS.actions.SIZE(SELECTED_SAGE_TRANSFERS)" >
                                                    <v-btn icon @click.stop="ON_SELECT_SAGE_TRANSFER_ORDER(item)">
                                                        <v-icon dark v-if="SELECTED_SAGE_TRANSFERS[item.docNum]">mdi-checkbox-marked-outline</v-icon> 
                                                        <v-icon dark v-else>mdi-checkbox-blank-outline</v-icon> 
                                                    </v-btn>
                                                </v-avatar>
                                                <v-avatar v-else :class="item.expand?'':''"
                                                    size="40"   
                                                    rounded="lg" class="ml-2"
                                                    :color="(item.processed && item.processed!='No')?'grey lighten-2':'grey '"  >
                                                    <v-img v-if="item.image"></v-img>
                                                    <v-icon v-else :disabled="(item.processed && item.processed!='No')?true:false">mdi-message-arrow-right-outline</v-icon>
                                                </v-avatar> 
                                            </v-layout>
                                        </v-list-item-action>  
                                        <v-list-item-content>
                                            <!-- <v-list-item-title>{{item.itemDesc}} </v-list-item-title> -->
                                            <v-list-item-subtitle>{{
                                                SageLoader('sage_inventory_transfer')?.totalCount - 
                                                (index +
                                                ( 
                                                   ( SageLoader('sage_inventory_transfer')?.page-1) *
                                                    SageLoader('sage_inventory_transfer')?.pageSize
                                                ) )
                                            
                                            }}. DOC NO: {{item.docNum}}</v-list-item-subtitle> 
                                            <v-list-item-subtitle>date:{{MBS.date.convert(item.syncDate,null,3   )}}</v-list-item-subtitle>
                                            <v-list-item-subtitle>From: {{findSageOutlet(item.fromLocCode)?.name || item.fromLocCode+"???"}} - To: {{findSageOutlet(item.toLocCode)?.name || item.toLocCode+"???"}}</v-list-item-subtitle>
                                            
                                        </v-list-item-content>
                                            
                                        <v-list-item-action>
                                            <v-card color="transparent" flat width="100">
                                                <v-layout class="ma-0" align-baseline justify-end>
                                                    <v-spacer></v-spacer>  
                                                    <span class="not-f2 pr-1">Items</span>
                                                    <div class=" not-f5 font-weight-bold grey--text text--darken-2">{{MBS.actions.SIZE(item?.items)}}</div>
                                                    
                                                </v-layout>
                                                <v-layout class="ma-0">
                                                    <v-spacer></v-spacer>
                                                    <v-btn disabled v-if="item.processed && item.processed!='No'" color="" small outlined>{{item?.processed}}</v-btn>
                                                </v-layout>
                                            </v-card>
                                        </v-list-item-action>  
                                        <v-list-item-action >  
                                            <v-menu bottom left  rounded="xl" >
                                                <template v-slot:activator="{ on }">
                                                <v-btn class="ml-2" 
                                                    icon
                                                    v-on="on" >
                                                    <v-icon>mdi-dots-vertical</v-icon>
                                                </v-btn>
                                                </template> 
                                                <v-card>
                                                    <v-card-title class="secondary white--text not-f4" >
                                                        INVOICE ({{item.invoiceNo}}) 
                                                    </v-card-title> 
                                                    <v-list  > 
                                                        <div v-for="(item_action, index_action) in SageTransferOrderActions" :key="index_action">
                                                            <v-list-item  @click="SAGE_TRANSFER_ACTION(item_action.action,item,index)" >
                                                                <v-list-item-action class="mr-3" ><v-icon>{{item_action.icon}}</v-icon></v-list-item-action>
                                                                <v-list-item-title class="">{{item_action.text}}</v-list-item-title>
                                                            </v-list-item> 
                                                        </div>
                                                            
                                                    </v-list> 
                                                </v-card>
                                            </v-menu> 
                                        </v-list-item-action>
                                    </v-list-item> 
                                    <v-divider  :key="' '+index"/> 
                                </template>
                            </v-list> 
                            <v-layout v-else fill-height justify-center align-center>
                                <v-chip close v-if="search" large class="px-5" @click:close="search=''">
                                    <v-icon>warning</v-icon> 
                                    <div class="not-f5 ml-2 grey--text" >No Order match "{{ search }}"</div>
                                </v-chip>
                                <v-chip v-else large class="px-5">
                                    <v-icon>warning</v-icon> 
                                    <div class="not-f6 ml-2 grey--text" >No Orders</div>
                                </v-chip>
                            </v-layout>
                        </v-card> 
                        
                    </v-card-text>  
                    
                    page:{{ SageLoader('sage_inventory_transfer')?.page }}
                    size:{{ SageLoader('sage_inventory_transfer')?.pageSize }}
                    count:{{ SageLoader('sage_inventory_transfer')?.totalCount }}
                     <v-pagination 
                        loading
                        :total-visible="7"
                        :value="SageLoader('sage_inventory_transfer')?.page"
                        :length="toNumber((SageLoader('sage_inventory_transfer')?.totalCount/SageLoader('sage_inventory_transfer')?.pageSize).toFixed(0))"
                        @input="DOWNLOAD_SAGE_TRANSFERS({sage_loader:{...SageLoader('sage_inventory_transfer'),page:$event}})"
                        @next="DOWNLOAD_SAGE_TRANSFERS({sage_loader:{...SageLoader('sage_inventory_transfer'),page:toNumber(SageLoader('sage_inventory_transfer').page)+1}})"
                        @previous="DOWNLOAD_SAGE_TRANSFERS({sage_loader:{...SageLoader('sage_inventory_transfer'),page:toNumber(SageLoader('sage_inventory_transfer').page)-1}})"  
                        ></v-pagination>
                </v-card> 
            </v-dialog> 

            <!-- // DAYSHIFTS -->
            <mbs-dayshift-selector  
                v-model="filter_date"
                :dialog="true"
                :filter_dayshifts="filter_dayshifts"
                :filter_dayshifts_fixed="true"
                color="text--darken-2 white"
                title_color="secondary"
                :max_from_date="MBS.date.moment().format('yyyy-MM-DD')" 
                :max_to_date="MBS.date.moment().format('yyyy-MM-DD')"
                :default_days="'30'" 
                @apply="APPLY_DAYSHIFTS($event,true)"
                /> 
        </div>
    </div> 
</template>

<script>
    import DATA from '../../../plugins/DATA'
    import {mapState,mapGetters } from "vuex"
    import { mdiInvoiceTextPlusOutline } from '@mdi/js';
    import { mdiReceiptTextArrowRight } from '@mdi/js';
    import DB from '../../../plugins/db/localDB'; 
    let PAGE_NAME = DATA.ITEMS.ITEMS.values    
    export default {
        name:PAGE_NAME, 
        props:['id','stock_outlet_code'], 
        data() {
            return {
                PAGE_LOAD:false,  
                PAGE_CURRENT:1,
                PAGE_SIZE:10,
                search:null, 
                warehouse_current_page:0,
                filter_dayshifts:null,
                input:{}, 
                filter_date:null,
                dialog_view_sage_transfer_orders:false,
                input_select_sage_invoices:false,
                SELECTED_SAGE_TRANSFERS:{},
                
                NAME_ITEMS:DATA.ITEMS.ITEMS.names,
                NAME_ITEM:DATA.ITEMS.ITEMS.name,
                VALUE_ITEMS:DATA.ITEMS.ITEMS.values,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value, 
                ADDING_ITEM:null,
                
                DELIVER_OPTION:[
                    {icon:"mdi-truck",name:"Orders to ship",number:"00"},
                    {icon:"mdi-truck-alert-outline",name:"Overdue Shipments",number:"00"},
                    {icon:"mdi-truck-delivery",name:"Delivering",number:"00"},
                    {icon:"mdi-truck-check",name:"Delivered",number:"00"},
                ],
                
                DATA:DATA,
                TOTAL_ITEM_VALUES:[ 
                    // {name:'Closing Stock (QTY)',value:'number_quantity',show_value:"number_quantity"},
                    // {name:'Total Cost',value:'number_total_cost',show_value:'number_total_cost_',money:true},
                    // {name:'Total Cost',value:'number_total_cost',show_value:'number_total_cost_',money:true},
                ], 
                filter_date:null,
                day_shift_data:null,
                dialog_doc_show:false,
                input_show_doc:{
                    // title:"INVOICE..",
                    top_header:true
                },
            }
        },
        created() {
            try { 
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);  
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME, 
                }) 
            }
        },
        mounted() {
            try {
                this.MBS.actions.header({
                show:false,
                type:'subToolbar', 
                
            }) 
                // console.log(this.SelectedCompany);
                // this.MBS.actions.header({
                //     show:true,
                //     type:'subToolbar', 
                //     images:null,
                //     color:'black',
                //     height:"300",
                //     opacity:'0.1'
                // }) 
                this.FEEDBACKS(1000)   
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'mounted',
                    page:PAGE_NAME, 
                }) 
            }
            
        },
        computed: {
            vs(){
                return this.$vuetify.breakpoint
            }, 
            vsh(){
                return this.vs.height
            }, 
            PATH_ITEM(){  
                let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true) 
                return path
            },  
            PAGE_TABS(){  
                let  default_tab = [
                    {name:"ORDERS TRANSACTIONS",icon:"mdi-transfer",show_if:(this_,item)=>true, },  
                    {name:"IN-TRANSIT",icon:"mdi-truck-delivery-outline",show_if:(this_,item)=>true, },  
                    {name:"DELIVERED",icon:"mdi-truck-check-outline",show_if:(this_,item)=>true, },  
                    {name:"INVENTORY SUMMARY",icon:"mdi-file-table-box-outline",show_if:(this_,item)=>true, }, 
                ] 
                return default_tab
            }, 
            TABLE_ACTIONS(){
                const page_tab= this.warehouse_current_page
                const table_tab= this.input?.current_table_tab || 0

                const refresh_inventory_action = {type:"action",btn:true,icon:"mdi-refresh",action:"refresh_inventory",color:"secondary", outlined:false,  text:"Refresh Inventory"}
                const refresh_production_action = {type:"action",btn:true,icon:"mdi-refresh",action:"refresh_production",color:"secondary", outlined:false,  text:"Refresh Production"}
                const refresh_purchases_action = {type:"action",btn:true,icon:"mdi-refresh",action:"refresh_purchases",color:"secondary", outlined:false,  text:"Refresh Purchases"}
                const refresh_stock_transfers_action = {type:"action",btn:true,icon:"mdi-refresh",action:"refresh_stock_transfers",color:"secondary", outlined:false,  text:"Refresh Stock Transfers"}
                const change_shift_action = {type:"action",btn:true,icon:"mdi-calendar-refresh",action:"change_shifts",color:"secondary", outlined:false,  text:"Refresh Sales / Change Shifts"}
                const manage_items_action = {type:"action",btn:true,icon:'mdi-tag',actions:[
                        {icon:"mdi-tag-plus",action:"create_item",text:'Create New Item'},
                        {icon:"mdi-tag",action:"manage_items",text:'Manage Items'},
                    ],color:"secondary", outlined:false,  text:"Items"}
                const manage_inventory_action = {type:"action",btn:true,icon:'mdi-file-table-box',actions:[
                        {type:"btn",btn:true,icon:mdiInvoiceTextPlusOutline,color:"secondary", text:"Stock Requisition", min_width:"",action:"stock_requisition"} , 
                        {icon:"mdi-package-down",action:"receive_stocks",text:'Receive Stocks'},
                        {icon:"mdi-transfer",action:"transfer_stock",text:'Transfer Stocks'}, 
                        {icon:"mdi-table-arrow-right",action:"sage_transfers",text:'Sage Transfers'}, 
                        {type:"btn",icon:"mdi-cog-transfer",color:"secondary",  text:"Adjust Stock",action:"adjust_stock"}, 
                    ],color:"secondary", outlined:false,  text:"Manage Inventory"}
                 
                const general_actions = [   
                    {icon:"mdi-package-variant-plus",action:"receive_stock_page",text:'Receive Stock Page'},
                    {type:"action",icon:"mdi-contrast-box",action:"stock_control",text:'Move to Stock Control'}, 
                    {type:"action",icon:"mdi-microsoft-excel",action:"export_excel",color:"secondary", outlined:false,  text:"Export to Excel"},  
                ]
                
                const sale_actions = [  
                    change_shift_action,manage_inventory_action,...general_actions 
                ]
                const stock_transfers_actions = [  
                    refresh_stock_transfers_action,manage_inventory_action,...general_actions 
                ]
                const purchase_actions = [  
                    refresh_purchases_action,manage_inventory_action,...general_actions 
                ]
                const production_actions = [  
                    refresh_production_action,manage_inventory_action,...general_actions 
                ]
                const inventory_actions = [  
                    refresh_inventory_action,manage_items_action,manage_inventory_action,...general_actions 
                ]

                
                let actions = []
                if (page_tab==3) {
                    actions = inventory_actions
                }else {
                    if (table_tab==0) {
                        actions = sale_actions
                    }else if (table_tab==1) {
                        actions = stock_transfers_actions
                    }else if (table_tab==2) {
                        actions = purchase_actions
                    }else if (table_tab==3) {
                        actions = production_actions
                    }
                }  
                return  actions
            },
            TABLE_TABS(){
                let warehouse_current_page = this.warehouse_current_page
                
                
                // const order_taps =  [
                //     {name:"Orders",show_if:(this_,item)=>{ 
                //             let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                //             return !item.shipping_status 
                //         },indicator:{
                //         color:'primary',
                //         value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                //     }},
                    
                //     {name:"In-Transit",show_if:(this_,item)=>{ 
                //             let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                //             return item.shipping_status == "in_transit"
                //         },indicator:{
                //         color:'primary',
                //         value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                //     }},  
                //     {name:"Delivered",show_if:(this_,item)=>{ 
                //             let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                //             return item.shipping_status == "delivered" 
                //         },indicator:{
                //         color:'primary',
                //         value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                //     }}, 
                // ] 
                const order_taps =  [
                    {name:"Sales",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false 
                            return item.order_type == "sale_order" &&  !item.shipping_status 
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},
                    
                    {name:"Transfers",show_if:(this_,item)=>{  
                            return  item.order_type == "stock_transfer" && !item.shipping_status  
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Purchases",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return  
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                    {name:"Production",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return 
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                ]
                const in_transit_taps =  [
                    {name:"Sales",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false 
                            return item.shipping_status == "in_transit"
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},
                    
                    {name:"Transfers",show_if:(this_,item)=>{  
                            return item.order_type == "stock_transfer" && item.shipping_status == "in_transit"
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Purchases",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return  
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                    {name:"Production",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return 
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                ]
                const delivered_taps =  [
                    {name:"Sales",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false 
                            return  item.shipping_status == "delivered" 
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},
                    
                    {name:"Transfers",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return 
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Purchases",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return  
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                    {name:"Production",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            return 
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                ] 
                const inventory_taps =  [
                    {name:"Stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            let stock_eis = this.toNumber(item[this.stock_outlet_code+"_number_eis_quantity"])>0?true:false
                            let stock_eis_w = this.toNumber(item[this.stock_outlet_code+"_number_w_quantity"])>0?true:false
                            return stock || stock_eis || stock_eis_w
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }},  
                    {name:"Out of stock",show_if:(this_,item)=>{ 
                            let stock = this.toNumber(item[this.stock_outlet_code+"_number_quantity"])>0?true:false
                            let stock_eis_w = this.toNumber(item[this.stock_outlet_code+"_number_w_quantity"])>0?true:false
                            return !stock_eis_w
                        },indicator:{
                        color:'primary',
                        value:(this_,MBS,data)=>{if(MBS){return MBS.SIZE(data)}}
                    }}, 
                ]
                let taps = order_taps
                if (warehouse_current_page ==1) { 
                    taps = in_transit_taps
                }else if (warehouse_current_page ==2) { 
                    taps = delivered_taps
                }else if (warehouse_current_page ==3) { 
                    taps = inventory_taps
                }  
               
                return  taps
            },
            FILTERS(){ 
                return null
                return [ 
                    // {
                    //     type:"autocomplete",value:"department_code",prepend_inner_icon:'mdi-format-list-group',clearable:true,filled:false,multiple:true
                    //     ,chips:true,deletable_chips:true,label:"Department",
                    //     select:{
                    //         name:'Departments',
                    //         value:'code',
                    //         text:'name'
                    //     }, 
                    //     required:false,sm:12,md:12,step_name:"Name"
                    // },

                    {
                        type:"autocomplete",value:"payment_method_name",prepend_inner_icon:'mdi-account-cash',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Payment",
                        select:{
                            name:'PaymentMethods',
                            value:'name',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    },   
                    {
                        type:"autocomplete",value:"receipt_number",barcode:true,prepend_inner_icon:'mdi-barcode',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Receipt Number",
                        select:{
                            name:'SalesOrders',
                            value:'receipt_number',
                            text:'receipt_number'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"created_uid",barcode:false,prepend_inner_icon:'mdi-tag-text',clearable:true,filled:false,
                        multiple:true,chips:true,deletable_chips:true,label:"Teller Name",
                        select:{
                            name:'Tellers',
                            value:'uid',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"customer_key",barcode:false,prepend_inner_icon:'mdi-tag-text',clearable:true,filled:false,
                        multiple:true,chips:true,deletable_chips:true,label:"Customer",
                        select:{
                            name:'Customers',
                            value:'key',
                            text:'name'
                        }, 
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"cashup_key",barcode:true,prepend_inner_icon:'mdi-account-cash-outline',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Cashup",
                        select:{
                            name:'Cashups',
                            value:'key',
                            text:'operating_date_'
                        }, 
                        search:{
                            filter:(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                    if(!a||!b){return false}
                                    a = ""+a; b = ""+b
                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                } 
                                let first = index(itemText,queryText)
                                let second = item?index(item.code,queryText):false
                                if(!item){return first} 
                                return first || second 
                            },
                            item_icon:{
                                name:'mdi-account-cash-outline',
                                tile:true
                            },
                            item_title:['till_name'],
                            item_subtitle:['teller_name','key','local_created_at_']
                        },
                        required:false,sm:12,md:6,step_name:"Name"
                    },   
                    {
                        type:"autocomplete",value:"day_shift_key",barcode:true,prepend_inner_icon:'mdi-network-pos',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Day Shift",
                        select:{
                            name:'DayShifts',
                            value:'key',
                            text:'operating_date_'
                        }, 
                        search:{
                            filter:(item, queryText, itemText) => { 
                                let index = (a,b)=>{
                                    if(!a||!b){return false}
                                    a = ""+a; b = ""+b
                                    return a.toLocaleLowerCase().indexOf(b.toLocaleLowerCase()) > -1 
                                } 
                                let first = index(itemText,queryText)
                                let second = item?index(item.code,queryText):false
                                if(!item){return first} 
                                return first || second 
                            },
                            item_icon:{
                                name:'mdi-network-pos',
                                tile:true
                            },
                            item_title:['outlet_name'],
                            item_subtitle:['teller_name','operating_date_']
                        },
                        required:false,sm:12,md:6,step_name:"Name"
                    }, 
                    {
                        type:"autocomplete",value:"outlet_code",barcode:true,prepend_inner_icon:'mdi-sitemap',clearable:true,filled:false,multiple:true,
                        chips:true,deletable_chips:true,label:"Outlet",
                        select:{
                            name:'Outlets',
                            value:'code',
                            text:'name'
                        }, 
                        required:false,sm:12,md:12,step_name:"Name"
                    },    
                ]
            }, 
            HEADER_SALE_ORDERS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:false},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Date",value:'local_created_at_',show:true},   
                    {id:0,name:"type",value:"order_id_type",show:true},  
                    {id:0,name:"Payment",value:"payment_method_name",show:false},  
                    {id:0,name:"Day Shift Code",value:'day_shift_key',show:false},   
                    {id:0,name:"Cashup Code",value:'cashup_key',show:false},      
                    {id:0,name:"K. No.",value:"receipt_number",align:"center",show:true},         
                    {id:0,name:"S. No.",value:"sage_invoice_number",align:"center",show:true},         
                    {id:0,name:"E. No.",value:(ctx,item)=>{
                        const eis_day_invoice_number = item.eis_day_invoice_number
                        const eis_payload = item.eis_payload
                        const invoiceNumber = eis_payload?.offline?.invoiceNumber
                        let eis_invoice = eis_day_invoice_number
                        if (invoiceNumber) {
                            eis_invoice = `${invoiceNumber} (${eis_day_invoice_number})`
                        }
                        return eis_invoice
                    },align:"center",show:true},         
                    {id:0,name:"Outlet",value:"outlet_name",show:false},         
                    {id:0,name:"Teller",value:"teller_name",show:true},         
                    {id:0,name:"Till",value:"till_name",show:false},         
                    {id:0,name:"Customer",value:'customer_name',show:true},    
                    {id:0,name:"Items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Cost Price",value:'total_cost_price_',align:'right',show:false},   
                    {id:0,name:"Discount",value:'all_discounts_',align:'right',show:false},   
                    {id:0,name:"Price",value:'total_sold_price_',align:'right',show:false},    
                    {id:0,name:"Sold Price(+)",value:'sum_amount_',align:'right',show:true}, 
                    {id:0,name:"Tax A",value:'taxable_a_',align:'right',show:false},   
                    {id:0,name:"Tax B",value:'taxable_b_',align:'right',show:false},   
                    {id:0,name:"Tax E",value:'taxable_c_',align:'right',show:false},   
                    {id:0,name:"VAT",value:'total_vat_',align:'right',show:false},   
                    {id:0,name:"Given Amount",value:'given_amount_',align:'right',show:false},   
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Order",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Flag as In-Transit",action:"frag_in_transit",icon:"mdi-truck-delivery"}, 
                        {name:"Flag as Delivered",action:"frag_delivered",icon:"mdi-truck-check"}, 
                        {name:"Report Deliver issue",action:"report_deliver_issue",icon:"mdi-truck-alert"}, 
                        {name:"Cancel Delivery",action:"cancel_delivery",icon:"mdi-truck-minus-outline"}, 
                        // {name:"Sales Report Page",action:"view_order_page",icon:mdiReceiptTextArrowRight}, 
                        // {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                        // {name:"log",action:"log",icon:"mdi-plus"},   
                    ]}, 
                ]
            }, 
            HEADER_TRANSFER_ORDERS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:false},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Date",value:'created_at_server_',show:true},   
                    {id:0,name:"type",value:"order_type",show:true},  
                    {id:0,name:"Payment",value:"payment_method_name",show:false},  
                    {id:0,name:"Day Shift Code",value:'day_shift_key',show:false},   
                    {id:0,name:"Code",value:'code',show:true},             
                    {id:0,name:"User",value:"user_name",show:false},   
                    {id:0,name:"From",value:"from_outlet_name",show:true},   
                    {id:0,name:"To",value:"to_outlet_name",show:true},   
                    {id:0,name:"Items",value:'total_quantity_',align:'right',show:true},  
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Order",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Flag as In-Transit",action:"frag_in_transit",icon:"mdi-truck-delivery"}, 
                        {name:"Flag as Delivered",action:"frag_delivered",icon:"mdi-truck-check"}, 
                        {name:"Report Deliver issue",action:"report_deliver_issue",icon:"mdi-truck-alert"}, 
                        {name:"Cancel Delivery",action:"cancel_delivery",icon:"mdi-truck-minus-outline"}, 
                        // {name:"Sales Report Page",action:"view_order_page",icon:mdiReceiptTextArrowRight}, 
                        // {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                        // {name:"log",action:"log",icon:"mdi-plus"},   
                    ]}, 
                ]
            }, 
            HEADER_RECEIVE_ORDERS(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"",value:'icon_image',color:"primary",size:40,tile:true,show:false},
                    {id:0,name:"Number",value:'no',show:false},   
                    {id:0,name:"Date",value:'local_created_at_',show:true},   
                    {id:0,name:"Payment",value:"payment_method_name",show:true},  
                    {id:0,name:"Day Shift Code",value:'day_shift_key',show:false},   
                    {id:0,name:"Cashup Code",value:'cashup_key',show:false},      
                    {id:0,name:"Receipt No.",value:"receipt_number",align:"center",show:true},         
                    {id:0,name:"Outlet",value:"outlet_name",show:false},         
                    {id:0,name:"Teller",value:"teller_name",show:true},         
                    {id:0,name:"Till",value:"till_name",show:false},         
                    {id:0,name:"Customer",value:'customer_name',show:true},   
                    {id:0,name:"Payment",value:"payment_method",show:false},     
                    {id:0,name:"Items",value:'total_quantity_',align:'right',show:true},   
                    {id:0,name:"Cost Price",value:'total_cost_price_',align:'right',show:false},   
                    {id:0,name:"Discount",value:'all_discounts_',align:'right',show:true},   
                    // {id:0,name:"Sold Price",value:'total_sold_price_',align:'right',show:true},   
                    {id:0,name:"Price",value:'total_sold_price_',align:'right',show:true},    
                    {id:0,name:"Sold Price(+)",value:'sum_amount_',align:'right',show:true}, 
                    {id:0,name:"Tax A",value:'taxable_a_',align:'right',show:false},   
                    {id:0,name:"Tax B",value:'taxable_b_',align:'right',show:false},   
                    {id:0,name:"Tax E",value:'taxable_c_',align:'right',show:false},   
                    {id:0,name:"VAT",value:'total_vat_',align:'right',show:false},   
                    {id:0,name:"Given Amount",value:'given_amount_',align:'right',show:false},   
                    {id:0,name:"update",value:'updated_at',show:false},   
                    {id:0,name:"action",align:"right",show:true,item:[ 
                        {name:"View Sales Report",action:"view_order",icon:"mdi-eye"}, 
                        {name:"Sales Report Page",action:"view_order_page",icon:mdiReceiptTextArrowRight}, 
                        {name:"Archive Sales Report",action:"archive_item",icon:"mdi-delete"},   
                        // {name:"log",action:"log",icon:"mdi-plus"},   
                    ]}, 
                ]
            }, 
            HEADER_INVENTORY(){
                const outlet_code = this.stock_outlet_code
                const items = this.ItemsData
                const received_items = items?.filter(i=>i[outlet_code+'_number_stock_receives'])
                const received = this.MBS.actions.SIZE(received_items)?true:false
                const transferred_items = items?.filter(i=>i[outlet_code+'_number_stock_transfers'])
                const transferred = this.MBS.actions.SIZE(transferred_items)?true:false
                const adjusted_items = items?.filter(i=>i[outlet_code+'_number_stock_adjustments'])
                const adjusted = this.MBS.actions.SIZE(adjusted_items)?true:false
                const sold_items = items?.filter(i=>i[outlet_code+'_number_sales'])
                const sold = this.MBS.actions.SIZE(sold_items)?true:false
                const returned_items = items?.filter(i=>i[outlet_code+'_number_returned_sales'])
                const returned = this.MBS.actions.SIZE(returned_items)?true:false
                

                let input = this.input
                let current_table_tab = input?input.current_table_tab:null
                let tiers = this.AllPricingTiers
                let headers = [
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:false},  
                    {id:0,name:"",value:'icon_image',color:"",size:35,tile:true,show:true},   
                    {id:0,name:"Barcode",value:"code_",align:"center",show:true},   
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Department",value:"item_department_name",cellClass:'',class:' b ',show:false}, 
                    {id:0,name:"Department Code",value:"item_department_code",cellClass:'',class:' b ',show:false},
                    {id:0,name:"Category",value:"category_name",show:true}, 
                    {id:0,name:"Category Code",value:"category_code",show:false}, 
                    {id:0,name:"Brand",value:"brand_name",show:false}, 
                    {id:0,name:"Brand Code",value:"brand_code",show:false}, 
                    {id:0,name:"Manufacturers",value:"manufacturer_name",show:false}, 
                    {id:0,name:"Manufacturer Code",value:"manufacturer_code",show:false},
                    {id:0,name:"Item Cost Price",value:"cost_price_",show:false}, 
                ]

                if (tiers) {
                    tiers.forEach(tier => {
                        headers.push({
                           name:tier.name, 
                           value:tier.key, 
                           class:' b ',show:false
                        })
                    });
                } 

                if (current_table_tab==3) { 
                    headers.push(...[
                        // {id:0,name:"Open Stock",value:this.stock_outlet_code+"_all_opening_stocks",align:"center",show:true}, 
                        {id:0,name:"Ordered",value:this.stock_outlet_code+"_number_stock_receives",align:"center",show:false}, 
                        {id:0,name:"Return Stock",value:this.stock_outlet_code+"_number_stocks_return",align:"center",show:false}, 
                        {id:0,name:"Adjustments",value:this.stock_outlet_code+"_number_stock_adjustments",align:"center",show:false}, 
                        {id:0,name:"Return Sales",value:this.stock_outlet_code+"_number_returned_sales",align:"center",show:false}, 
                        {id:0,name:"Sold",value:this.stock_outlet_code+"_number_sales",align:"center",show:true},  
                        // {id:0,name:"Stock",value:this.stock_outlet_code+"_number_quantity",align:"center",show:true},   
                        {id:0,name:"Tax Group",value:"tax_group_name",align:"center",show:false}, 
                        {id:0,name:"Tax Group Code",value:"tax_group_code",align:"center",show:false},  
                    ])
                }else{ 
                    headers.push(...[
                        {id:0,name:"Open Stock",value:this.stock_outlet_code+"_all_opening_stocks",align:"center",show:true}, 
                        {id:0,name:"Received",value:this.stock_outlet_code+"_number_stock_receives",align:"center",show:received}, 
                        {id:0,name:"Transferred",value:this.stock_outlet_code+"_number_stock_transfers",align:"center",show:transferred}, 
                        {id:0,name:"Return Stock",value:this.stock_outlet_code+"_number_stocks_return",align:"center",show:returned}, 
                        {id:0,name:"Adjustments",value:this.stock_outlet_code+"_number_stock_adjustments",align:"center",show:adjusted}, 
                        {id:0,name:"Return Sales",value:this.stock_outlet_code+"_number_returned_sales",align:"center",show:false}, 
                        {id:0,name:"Sold",value:this.stock_outlet_code+"_number_sales",align:"center",show:sold},  
                        {id:0,name:"Undelivered",value:this.stock_outlet_code+"_number_undelivered",align:"center",show:true},  
                        {id:0,name:"In-Transit",value:this.stock_outlet_code+"_number_in_transit",align:"center",show:true},  
                        {id:0,name:"Delivered",value:this.stock_outlet_code+"_number_delivered",align:"center",show:true},  
                        {id:0,name:"K. Stock",value:this.stock_outlet_code+"_number_quantity",align:"center",show:true},  
                        {id:0,name:"E. Stock",value:this.stock_outlet_code+"_number_eis_quantity",align:"center",show:true},  
                        {id:0,name:"W. Stock",value:this.stock_outlet_code+"_number_w_quantity",align:"center",show:true},  
                        {id:0,name:"Tax Group",value:"tax_group_name",align:"center",show:false}, 
                        {id:0,name:"Tax Group Code",value:"tax_group_code",align:"center",show:false},  
                    ])
                }
                headers.push({id:0,name:"action",align:"right",show:true,item:[  
                    {name:"Transfer Stock",action:"transfer_item_stock",icon:"mdi-transfer"}, 
                    {name:"Receive Stock",action:"receive_item_stock",icon:"mdi-package-down"}, 
                    {name:"Stock History",action:"transferred_item_history",icon:"mdi-clipboard-text-clock"},  
                ]}) 
                return headers
            },
            HEADER_ITEMS(){
                const warehouse_current_page = this.warehouse_current_page
                const input = this.input
                const current_tab = input?input.current_table_tab:null
                const sales = this.HEADER_SALE_ORDERS
                const transfers = this.HEADER_TRANSFER_ORDERS
                const receive = this.HEADER_RECEIVE_ORDERS
                const inventory = this.HEADER_INVENTORY

                let headers = sales
                if (current_tab == 1) {
                    headers = transfers
                }else if (current_tab == 2) {
                    headers = receive
                }
                if (warehouse_current_page == 3) { 
                    headers = inventory
                }  
                return headers

            },
            HEADER_ITEMS2(){
                return [ 
                    {id:1,name:"General",title:true}, 
                    {id:0,name:"No.",value:'no',show:true},  
                    {id:0,name:"Barcode",value:"code",align:"center",show:true},      
                    {id:0,name:"Name",show:true}, 
                    {id:0,name:"Category",value:"category_code",show:true}, 
                    {id:0,name:"Brand",value:"brand_code",show:true}, 
                    {id:0,name:"Cost",value:"cost_price",show:true}, 
                    {id:0,name:"Retail",value:"retail_price",show:true}, 
                    {id:0,name:"Wholesale",value:"wholesale_price",show:true}, 
                    {id:0,name:"Tax",value:"tax",show:true}, 
                    {id:0,name:"action",align:"right",show:true,item:[  
                        {name:"Edit "+this.NAME_ITEM,action:"edit_item",icon:"mdi-pencil"},
                        {name:"Delete "+this.NAME_ITEM,action:"delete_item",icon:"mdi-delete"},
                    ]}, 
                ]
            },  
            Selectors(){ 
                let Outlets = this.StockOutletsData 
                let ToOutlets = this.ToOutlets 
                let Items = this.ItemsData  
                let ItemCategories = this.ItemCategories
                let Brands = this.Brands
                let Manufacturers = this.Manufacturers
                let TaxGroups = this.TaxGroups
                let PricingTiers = this.AllPricingTiers
                let ReceiveStockOptions = this.ReceiveStockOptions

                console.log(Outlets,"Outlets.....");
                
                return{
                    Outlets: Outlets,
                    ToOutlets: ToOutlets,
                    Items: Items,
                    ItemCategories: ItemCategories,
                    Brands: Brands,
                    Manufacturers: Manufacturers, 
                    TaxGroups: TaxGroups, 
                    PricingTiers: PricingTiers, 
                    ReceiveStockOptions: ReceiveStockOptions, 
                }
            },
            SageTransferOrderActions(){ 
                let actions = [ 
                    {type:"action",btn:true,icon:'mdi-checkbox-marked-outline',action:"select_sage_transfer_order", text:"Select"},
                    {type:"action",btn:true,icon:'mdi-cloud-sync',action:"process_sage_transfer_order", text:"Process Transfer"},   
                    {type:"action",btn:true,icon:'mdi-cloud-sync-outline',action:"mark_sage_transfer_order_processed", text:"Mark as Processed"},
                    {type:"action",btn:true,icon:'mdi-delete',action:"delete_sage_transfer_order", text:"Delete Transfer"},   
                ]
                return  actions
            },
            /////////

            liveTime(){
                let time = this.MBS.date.live 
                return time
            }, 
            online(){   
                return this.$store.getters.getOnlineStatus
            },
            onlineLan(){   
                const LAN = this.LAN
                const current_server = this.CurrentServer
                const online = LAN?.[current_server?.api_link] 
                console.log(LAN,"LAN...");
                console.log(current_server,"current_server...");
                console.log(online,"online...----***");
                
                return online
            },
            onlineIndicator(){ 
                const online = this.EventSageInventoryTransfer
                let light = "green"
                if (!online) {
                    light = "red"
                } 
                return light
            },
            EventSageInventoryTransfer(){
                const events = this.EVENTS
                const server = this.CurrentServer
                const link = server?.api_link
                const event = events?.["sage_inventory_transfer"] 
                console.log(event,"ee...-..");
                
                const event_active = event?.active
                const event_link = event?.active_links?.findIndex(link=>link == link) != -1
                console.log(event_active,"event_active.....");
                console.log(event_link,"event_link.....");
                return event_active && event_link
            }, 
            SageLoaders(){
                let loader = this.SAGE_LOADER
                console.log(this.SAGE_LOADER,"this.SAGE_LOADER.......");
                
                let server = this.CurrentServer
                let link = server?.api_link
                return loader?.[link]
            }, 
            SageLoader(){
                let loader = this.SageLoaders
                return type =>loader?.[type] || {}
            }, 
            ...mapState({
                loading:state=>state.load.loading,
                processes:state=>state.load.processes,
                responses:state=>state.load.responses,
            }),
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                ud: state=> state.users[(DATA.ITEMS.USER_DETAILS.values).toUpperCase()],
                SHOW_OFFLINE: state=> state.items['SHOW_OFFLINE'],
                online: state=> state.users['ONLINE_STATUS'],
                SERVERS: state=> state.lan['SERVERS'],
                LAN: state=> state.lan['LAN'],
                EVENTS: state=> state.lan['EVENTS'],
                SAGE_LOADER: state=> state.lan['SAGE_LOADER'],
                SERVER_INFO: state=> state.lan['SERVER_INFO'],
            }),
            ...mapState({
                SalesOrders: state=> state.items[(DATA.ITEMS.SALE_ORDERS.values).toUpperCase()],
                JoinedSalesOrders: state=> state.join[(DATA.ITEMS.SALE_ORDERS.values).toUpperCase()], 

                SelectedCompany: state=> state.items["SELECTED_COMPANY"], 
                LocalWarehouseSessions: state=> state.items[(DATA.ITEMS.LOCAL_WAREHOUSE_SESSIONS.values).toUpperCase()], 
                Items: state=> state.items[(DATA.ITEMS.ITEMS.values).toUpperCase()],
                JoinedItems: state=> state.join[(DATA.ITEMS.ITEMS.values).toUpperCase()], 
                ItemCategories: state=> state.items[(DATA.ITEMS.ITEM_CATEGORIES.values).toUpperCase()],
                Brands: state=> state.items[(DATA.ITEMS.BRANDS.values).toUpperCase()],
                Manufacturers: state=> state.items[(DATA.ITEMS.MANUFACTURERS.values).toUpperCase()], 
                TaxGroups: state=> state.app[(DATA.ITEMS.TAX_GROUPS.values).toUpperCase()], 
                StockOutlets: state=> state.items[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()],
                JoinedStockOutlets: state=> state.join[(DATA.ITEMS.STOCK_OUTLETS.values).toUpperCase()], 
                SageTransferOrders: state=> state.items[(DATA.ITEMS.SAGE_TRANSFERS.values).toUpperCase()],
                JoinedSageTransferOrders: state=> state.join[(DATA.ITEMS.SAGE_TRANSFERS.values).toUpperCase()], 
                StockOrders: state=> state.items[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()],
                JoinedStockOrders: state=> state.join[(DATA.ITEMS.STOCK_ORDERS.values).toUpperCase()], 
                Devices: state=> state.items[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                JoinedDevices: state=> state.join[(DATA.ITEMS.DEVICES.values).toUpperCase()],
                
                PricingTiers: state=> state.items[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
                JoinedPricingTiers: state=> state.join[(DATA.ITEMS.PRICING_TIERS.values).toUpperCase()], 
                DefaultPricingTiers: state=> state.app['DEFAULT_PRICING_TIERS'], 
                ReceiveStockOptions: state=> state.app['RECEIVE_STOCK_OPTIONS'], 
                LocalDevices: state=> state.locals[(DATA.ITEMS.LOCAL_DEVICES.values).toUpperCase()],
            }), 
            DevicesData(){
                return this.JoinedDevices?this.JoinedDevices:this.Devices
            },
            ItemData(){   
                let items = this.JoinedItems?this.JoinedItems:this.Items   
                return items  
            },
            AttachedDevice(){
                let devices = this.LocalDevices  
                if(!devices){return null}
                let filtered = devices.find(pc=>pc.key == 'attached_device')
                return filtered
            },
            CurrentServer(){
                let device = this.AttachedDevice
                const server_code = device?.server_code  
                const server = this.findServer(server_code)   
                return server
            },
            findServer(){
                let devices = this.DevicesData
                return (code)=>devices?.find(item=>item.code == code)
            },
            ItemSorted(){   
                let items = this.ItemData
                if(!items){return null} 
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("name",true))   
                return list  
            },   
            ItemCategoriesData(){   
                let items = this.JoinedItemCategories?this.JoinedItemCategories:this.ItemCategories  
                return items  
            }, 
            ItemCategorySorted(){   
                let items = this.ItemCategoriesData
                if(!items){return null} 
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("name",true))   
                return list  
            },  
            ItemByCategory(){  
                let category = this.SELECTED_ITEM_CATEGORY 
                let items = this.ItemData
                if(!category || !items){return null}
                let filtered = items.filter(item=>item.category_code==category.code)
                if(!filtered){return null}
                let list = [...filtered]
                list.sort(this.MBS.actions.dynamicSort("name",true))   
                return list  
            },
            findSageItem(){
                const items = this.ItemData
                return (sage_code)=>items?.find(item=>item.sage_code == sage_code || item.code == sage_code)
            }, 
            InventoryItems(){ 
                const items = this.ItemData 
                const filtered = items?.filter(item=>{
                    const service = item.item_type_key == "service"
                    const child = item.item_type_key == "child"
                    const parent = item.item_type_key == "parent"
                    const inventory_item_code = item?.inventory_item_code
                    const inventory_item_key = item?.inventory_item_key
                    const inventory_item_keycode = inventory_item_key?inventory_item_key:inventory_item_code
                    const inventory = !inventory_item_keycode || inventory_item_keycode == "main"?true:false
                    return inventory && !service && !child && !parent
                })   
                console.log(items,'......');
                console.log(filtered,'filtered......');
                
                return filtered
            },
            StockOrdersData(){ 
                const StockOrders = this.StockOrders 
                const JoinedStockOrders = this.JoinedStockOrders
                const items = JoinedStockOrders?JoinedStockOrders:StockOrders 
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("created_at_server",false)) 
                console.log(StockOrders,'.........StockOrdersData');
                return list
            }, 
            OutletData(){   
                let items = this.JoinedStockOutlets?this.JoinedStockOutlets:this.StockOutlets  
                return items  
            },
            findSageOutlet(){
                const outlets = this.OutletData
                return (sage_code)=>{
                    const search_code =  String(sage_code)?.trim()
                    return outlets?.find(outlet=>outlet.sage_code == search_code)
                }
            }, 
            SalesOrdersData(){ 
                let SalesOrders = this.SalesOrders
                let JoinedSalesOrders = this.JoinedSalesOrders
                let items = JoinedSalesOrders?JoinedSalesOrders:SalesOrders

                console.log(items?.find(it=>it.key=="1759412076350"),'items---------+++');
                console.log(SalesOrders,'SalesOrders---------+++');
                console.log(JoinedSalesOrders,'JoinedSalesOrders---------+++');
                
                if(!items){return null}
                let list = [...items]
                list.sort(this.MBS.actions.dynamicSort("local_created_at",false))  
                return list
            }, 
            
             
            WarehouseSession(){   
                let sessions = this.LocalWarehouseSessions
                let company = this.SelectedCompany 
                if(!sessions || !company){return null}
                let local_company = sessions[0]
                let local_company_key = local_company?local_company.company_key:null
                let company_key = company?company.company_key:null
                if (local_company_key && company_key!=local_company_key) {
                    console.log('close........');
                    this.CLOSE_WAREHOUSE()
                }
                console.log(sessions,'sessions.s...');
                console.log(company,'company..s..');
                return sessions[0]
            }, 
            ThisOutlet(){
                const outlets =  this.OutletData
                const sessions = this.WarehouseSession
                const stock_outlet_code = this.stock_outlet_code
                const outlet = outlets?.find(item=>item.code == stock_outlet_code)
                console.log(stock_outlet_code,'stock_outlet_code......');
                console.log(outlet,'ThisOutlet......');
                console.log(sessions,'sessions......');
                
                return outlet
            },

            TableData(){
                let warehouse_current_page = this.warehouse_current_page
                const InventoryItems = this.InventoryItems
                const SalesOrdersData = this.SalesOrdersData
                const orders = this.StockOrdersData
                const transfers = orders?.filter(item=>item.order_type == "stock_transfer")
                // const input = this.input
                // const current_table_tab = input?.current_table_tab
                let mixed = []
                if (transfers) {
                    mixed.push(...transfers)
                }if (SalesOrdersData) {
                    mixed.push(...SalesOrdersData)
                }

                console.log(transfers,'transfers......');
                console.log(warehouse_current_page,'warehouse_current_page......');
                console.log(SalesOrdersData,'SalesOrdersData......');
                // console.log(current_table_tab,'current_table_tab......');
                

                let data = mixed

                // if (current_table_tab == 1) {
                //     data = transfers  
                // }
                
                if (warehouse_current_page == 3) { 
                    data = InventoryItems
                }   
                return data 
            },

            SageTransferOrdersData(){
                const SageTransferOrders = this.SageTransferOrders
                const JoinedSageTransferOrders = this.JoinedSageTransferOrders  
                const items =  JoinedSageTransferOrders?JoinedSageTransferOrders:SageTransferOrders
                console.log(items,"........SageTransferOrdersData "); 
                items?.sort(this.MBS.actions.dynamicSort("transferDate",false))      
                return items
            },
            SageTransferOrdersSearch(){
                const search = this.search
                const transfers = this.SageTransferOrdersData
                if(!search){return transfers}
                const filter = transfers?.filter(transfer=>{
                    let name_index = this.MBS.actions.TEXT_UP0(transfer.docNum)?.indexOf(this.MBS.actions.TEXT_UP0(search))
                    // let number_index = this.MBS.actions.TEXT_UP0(transfer.transferNo)?.indexOf(this.MBS.actions.TEXT_UP0(search)) 
                    return name_index!=-1 
                    // return name_index!=-1 || number_index!=-1
                })
                return filter
            }, 

            AllActionItems(){  
                return [ 
                    {
                        icon:"mdi-gesture-tap-hold",
                        action:"click_mode", 
                        name:"Click Mode",
                        color:"green", 
                        show_if:(data)=>data?true:false
                    },{ 
                        icon:"remove_shopping_cart",
                        action:"clear_sales", 
                        name:"Clear",
                        color:"red", 
                        show_if:(data)=>data?true:false
                    },{
                        icon:"mdi-refresh",
                        action:"refresh_data", 
                        name:"Refresh",
                        color:"",
                        type:"",
                        disable:false

                    },{
                        icon:"mdi-garage-variant-lock",
                        action:"close_warehouse", 
                        name:"Close Warehouse",
                        color:"",
                        type:"",
                        disable:data=>!data?true:false
                    },
                    { 
                        // icon:"mdi-plus-box",
                        icon:"mdi-plus-box",
                        action:"create_item_", 
                        name:"Create / Add",
                        color:"",
                        type:"sales",
                        disable:data=>!data?true:false,
                        menu:{
                            name:"Create / Add",
                            items:[
                                {icon:"mdi-tag-plus",action:"create_item",name:"Create New Item"},
                                {icon:"mdi-group",action:"create_item_kit",name:"New Item Kit / Service"},
                                {icon:"mdi-human-dolly",action:"add_supplier",name:"Add New Supplier"},
                                {icon:"mdi-basket",action:"add_customer",name:"Add New Customer"},
                            ]
                        }
                    },{ 
                        icon:"mdi-table-search",
                        action:"", 
                        name:"Manage",
                        color:"",
                        disable:data=>!data?true:false,
                        menu:{
                            name:"Manage",
                            items:[
                                {icon:"mdi-tag",action:"manage_items",name:"Manage Item"},
                                {icon:"mdi-group",action:"manage_item_kits",name:"Manage Item Kit / Service"},
                                {icon:"mdi-human-dolly",action:"manage_suppliers",name:"Manage Supplier"},
                                {icon:"mdi-basket",action:"manage_customers",name:"Manage Customer"},
                            ]
                        }
                    }, 
                    
                    { 
                        icon:"mdi-package-variant-plus",
                        action:"received_stock", 
                        name:"Received Stock", 
                        color:"", 
                        disable:data=>!data?true:false
                    },
                    { 
                        icon:"mdi-package-variant-minus",
                        action:"transferred_stock", 
                        name:"Transferred Stock", 
                        color:"", 
                        disable:data=>!data?true:false
                    }, { 
                        icon:"mdi-package-variant-remove",
                        action:"returned_stock", 
                        name:"Returned Stock", 
                        color:"", 
                        disable:data=>!data?true:false
                    }, 
                    { 
                        icon:"mdi-tag-faces",
                        action:"adjust_stock", 
                        name:"Adjust Stock", 
                        color:"", 
                        disable:data=>!data?true:false
                    }, 
                    { 
                        icon:"mdi-tag-search",
                        action:"stock_taking", 
                        name:"Stock Taking", 
                        color:"", 
                        disable:data=>!data?true:false
                    },{ 
                        icon:"mdi-tag-heart",
                        action:"expiries", 
                        name:"Expiries", 
                        color:"", 
                        disable:data=>!data?true:false
                    },  
                ]
            },
            ActionItems(){ 
                let actions = this.AllActionItems
                let printer = this.CurrentReceiptPrinter 
                let isPrinter = printer?true:false
                if(!actions){return null}
                let newActions = actions.filter(item=>{
                    // if (isPrinter) {
                    //     return !item.no_fiscal_printer
                    // }
                    return true
                })
                return newActions
            }, 
        },
        methods: {  
            TABLE_ACTION(action,item){
                try {
                    let route = this.route
                    let fullPath = route?route.fullPath:null
                     console.log(action,'action');
                    if (action == "refresh") {
                        let mbs_text = this.MBS.text.item_action("Item Data","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "refresh_inventory") {
                        let mbs_text = this.MBS.text.item_action("Item Inventory","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo,
                            action:{
                                code:PAGE_NAME+"=RELOAD-ITEMS", 
                            } 
                        })
                    }else if (action == "change_shifts") {
                        this.SELECT_DAY_SHIFT()
                    }else if (action == "sync_sage_orders") {
                        //  this.dialog_view_sage_transfer_orders = true
                         this.MBS.events.$emit("MANAGE_SAGE_INVENTORY_TRANSFER")
                    }else if (action == "sage_transfers") { 
                         this.MBS.events.$emit("MANAGE_SAGE_INVENTORY_TRANSFER")
                    }else if (action == "create_item") {
                        this.CREATE_ITEM()
                    }else if (action == "create_item_kit") {
                        this.CREATE_ITEM_KIT()
                    }else if (action == "manage_items") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/items",true))
                    }else if (action == "manage_item_kit") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/item-kit",true))
                    }else if (action == "stock_requisition") {
                        this.STOCK_REQUISITION() 
                    }else if (action == "receive_stocks") {
                        this.RECEIVE_STOCK() 
                    }else if (action == "receive_stock_page") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/receive-stock",true))
                    }else if (action == "transfer_stock") {
                        this.TRANSFER_STOCK()
                    }else if (action == "stock_control") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control",true))
                    }else if (action == "warehouse") {
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/warehouse",true))
                    }else if (action == "adjust_stock") { 
                        this.MBS.actions.go(this.MBS.actions.COMPANY_LINK("/stock/stock-control/adjust-stock",true))
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TABLE_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            SAGE_TRANSFER_ACTION(action,item,index){
                try {  
                    console.log(action,item,index,'------------');
                    
                    if (action == "refresh") { 
                        this.REFRESH_ORDERS()
                    }else if (action == "process_sage_transfer_order") {   
                        this.ON_SUBMIT_SAGE_TRANSFER_ORDER(item,index,true)
                    }else if (action == "delete_sage_transfer_order") { 
                        this.ON_PROCESS_SAGE_TRANSFER({
                            order:item,
                            index:index,
                            confirm:true,
                            notify:true,
                            status:"Deleted",
                            action:"Delete"
                        })
                    }else if (action == "mark_sage_transfer_order_processed") { 
                        this.ON_PROCESS_SAGE_TRANSFER({
                            order:item,
                            index:index,
                            confirm:true,
                            notify:true,
                            status:"Printed",
                            action:"Mark"
                        })
                    }else if (action == "select_sage_transfer_order") { 
                        this.ON_SELECT_SAGE_TRANSFER_ORDER(item)
                    }  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SAGE_TRANSFER_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ITEM_ACTION(action,item,option){
                try {     
                    console.log(action,'***************');
                    let link = "/stock/stock-control/"+(item?item.key:null)
                    const path = this.MBS.actions.COMPANY_LINK(link,true)  

                    let doc_title = null
                    let doc_type = null
                    if (item?.account_type == "on_account") {
                            doc_title = "INVOICE"
                            doc_type = "invoice"
                    } else {
                        doc_title = "RECEIPT"
                        doc_type = "invoice" 
                    }
                    if (action == "view_order_page") {
                        let receipt_key = item?item.key:null
                        this.MBS.actions.go("/sales-receipt/"+receipt_key) 
                    }else if (action == "view_order") {  
                        if (doc_title) { 
                            this.SHOW_DIALOG_DOCUMENT({
                                data:item,
                                doc_title:doc_title,
                                doc_type:doc_type,
                            })
                        }
                    }else if (action == "frag_in_transit") { 
                        this.ON_FLAG_IN_TRANSIT(item)
                    }else if (action == "frag_delivered") { 
                        this.ON_FLAG_DELIVERED(item)
                    }else if (action == "report_deliver_issue") { 
                        
                    }else if (action == "cancel_delivery") { 
                        
                    } 
                    
                    if (action == "on_row_clicked") {
                         
                    }else if (action == "transfer_item_stock") {
                        this.TRANSFER_STOCK(item.key) 
                    }else if (action == "receive_item_stock") {
                        this.RECEIVE_STOCK(item.key) 
                    }else{}
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ITEM_ACTION',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            async ADD_ITEM(item_key, item_code){
                try { 

                    console.log(item_key,item_code,);
                    this.FULLSCREEN() 
                    const settings = this.CompanySettings 
                    const activate_stock_level = settings?settings.activate_stock_level:null 

 
                    const outlet_code = this.stock_outlet_code
                    let quantity = null
                    let item_price = null 
                    let scales = this.Scales  
                    
                    const items = this.ItemsData 
                    const moment = this.MBS.date.moment
                    const selecting_list_key = moment?moment().valueOf():null

                    
                    
                    if (items) {
                        setTimeout(() => {
                            this.search_item=null 
                        }, 500);
                        let item_selected = items.find(item=>{
                            return  item_key?item.key == item_key:item.code == item_code
                        }) 
                        if (!item_selected) {
                            this.MBS.actions.dialog()
                            let isTimestamp = this.MBS.actions.isTimestamp(item_code)
                            if(isTimestamp){ 
                                console.log(item_code,'isTimestamp...')
                            }else{
                            }
                            setTimeout(() => {    
                                this.MBS.actions.dialogConfirmPassword({
                                    show:true,
                                    icon:mdiTagHidden,
                                    title:'ITEM NOT FOUND',
                                    text:"Item (" + item_code + ") not found. Please ensure that items are loaded and refreshed. Alternatively, you can use scanned barcode to add the item as new.",
                                    btnYes:"ADD AS NEW ITEM",
                                    btnNo:"REFRESH ITEMS",
                                    action:{
                                        code:PAGE_NAME+'=CREATE_AS_NEW_ITEM',
                                        item_code:item_code,
                                        silent_btn_no:true,
                                        phone_number_start:true,
                                        all_users:true,
                                        get_access:{
                                            permission_type:"action", 
                                            permission_to:"write", 
                                            action_name:DATA.ITEMS.ITEMS.names
                                        }
                                    }
                                }) 
                            }, 500); 
                            return 
                        } 
                        
                        //check stock level
                        if (activate_stock_level) {
                            
                            let stock_settings = await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                item:item_selected,
                                outlet_code:outlet_code,
                                notify:false
                            })

                            // console.log(stock_settings,'stock_settings-*---------------****');
                            
  
                            let allow_sell = stock_settings?stock_settings.allow_sell:null 
                            let stop_selling_level = stock_settings?stock_settings.stop_selling_level:null 
                            let quantity = stock_settings?stock_settings.quantity:null 
                            let stop_sale = quantity <= stop_selling_level?true:false
                            if (!allow_sell && stop_sale) {
                                await this.MBS.actions.CHECK_ITEM_STOCK_SETTINGS({
                                    item:item_selected,
                                    outlet_code:outlet_code,
                                    notify:true
                                })
                                return
                            } 
                        }


                        /// if array
                        let newItem = {
                            ...item_selected,  
                            quantity:quantity?quantity:1,
                        }

                       
                        console.log(newItem,'newItem......');

                        //display selected item
                        // this.CUSTOMER_DISPLAY({
                        //     type:'add_item',
                        //     item:newItem
                        // }) 

                        this.MBS.events.$emit("ADD_STOCK_TRANSFER_SELECTED_ITEMS",{
                            item_key:item_key,
                            item_code:item_code,  
                            selected_item:newItem,
                        }) 
                        return 
                    }
                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADD_ITEM',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            STOCK_REQUISITION(item_key, item_code){
                try {  
                    this.MBS.events.$emit("INVENTORY_STOCK_REQUISITION",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'STOCK_REQUISITION',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            RECEIVE_STOCK(item_key, item_code){
                try {  
                    console.log(item_key,item_code,);
                     this.MBS.events.$emit("INVENTORY_STOCK_RECEIVE",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'RECEIVE_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            TRANSFER_STOCK(item_key, item_code){
                try {  
                    console.log(item_key,item_code,);
                     this.MBS.events.$emit("INVENTORY_STOCK_TRANSFER",{
                        item_key:item_key,
                        item_code:item_code,   
                    })  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'TRANSFER_STOCK',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            ON_SUBMIT_SAGE_TRANSFER_ORDER(order,index,process){
                try {  
                    if (this.MBS.actions.SIZE(this.SELECTED_SAGE_TRANSFERS)&&!process) {
                        this.ON_SELECT_SAGE_TRANSFER_ORDER(order)
                    }else{
                        const company = this.SelectedCompany
                        const company_key = company?.company_key
                        const ud = this.ud
                        const uid = ud?.uid || null
                        let unavailable_item = []
                        const mapInvoiceToOrder = (rawTransfer) => {
                            const timestamp = Date.now(); 
                            const moment = this.MBS.date.moment
                            const update_key = moment?moment().valueOf():null
                            const order_code = rawTransfer.docNum?.replace(/\s/g, '') || null
                            const from_outlet_code =  this.findSageOutlet(rawTransfer.fromLocCode)?.code || null
                            const to_outlet_code =  this.findSageOutlet(rawTransfer.toLocCode)?.code || null
                            const from_outlet_name =  this.findSageOutlet(rawTransfer.fromLocCode)?.name || null
                            const to_outlet_name =  this.findSageOutlet(rawTransfer.toLocCode)?.name || null
                        
                            return {
                                "order_type": "stock_transfer",
                                "docNum":order_code,
                                "code":order_code,
                                "selected_document_key":order_code,
                                "company_key":company_key,
                                "from_outlet_code": from_outlet_code,
                                "to_outlet_code": to_outlet_code,
                                "from_outlet_name": from_outlet_name,
                                "to_outlet_name": to_outlet_name,
                                "received_date": rawTransfer.customerName,
                                "order_record": "new_record",
                                "description": "Sage Transfer Order", 
                                "created_uid": uid, 
                                "local_created_at": update_key, 
                                "logged_uid": uid, 
                                "order_option": "direct_transfer_stock",
        
                                "items": rawTransfer.items.map((item, idx) => {
                                    const itemCode = String(item.itemNo).trim();
                                    
                                    // 2. Find local item details from this.ItemsData
                                    const localItem = this.findSageItem(itemCode);    
                                
                                    if(!localItem){
                                        unavailable_item.push(item)
                                        return
                                    }
                                    const updating_item = {
                                        // Merge additional local details if needed
                                        // ...localItem, 
                                        "quantity": item.qtyTransferred,
                                        
                                        // Metadata
                                        "order_key": timestamp,
                                        "update_key": timestamp, 
                                        "sage_item_key": itemCode,  
                                        "key":  localItem?.key,
                                        "barcode":  localItem?.barcode,
                                        "code": localItem?.code || itemCode,
                                        "item_code": localItem?.code,
                                        "item_key": localItem?.key,
                                        "name": item.itemDescription?.trim() || localItem.name || "Unknown Item",  
                                    };
                                    return updating_item
                                })
                            };
                        };
        
                        const new_order = mapInvoiceToOrder(order);
        
                        console.log(order,"-------------sage_order*********");
                        console.log(new_order,"-------------new_order*********");
                        console.log(unavailable_item,"-------------unavailable_item*********");
                        
                        if (this.MBS.actions.SIZE(unavailable_item)) {
                            let message = "The following Item(s) not found in kipcount: "
                            unavailable_item.forEach((item,index) => {
                                message =message+ `\n${index+1}. ${item.itemCode?.trim()} = ${item.itemDescription?.trim()}`
                            });
                            this.MBS.actions.dialog({
                                show:true,
                                title:"ITEM(S) NOT FOUND",
                                text:message,
                                btnYes:"Mark as Processed",
                                btnNo:"Delete Transfer",
                                action:{
                                    code:PAGE_NAME+'=TRANSFER_SAGE_ITEMS_NOT_FOUND', 
                                    data:new_order,
                                    silent_btn_no:true
                                }
                            })
                        }else{
                            let message = `Are you sure you want to transfer the following Item(s) from ${new_order?.from_outlet_name} to ${new_order?.to_outlet_name}?   
                            `
                            new_order?.items?.forEach((item,index) => {
                                message =message+ `\n${index+1}. barcode = ${item.code?.trim()} 
                                name = ${item.name?.trim()}
                                Quantity = ${item.quantity}
                                `
                            });
                            this.MBS.actions.dialog({
                                show:true,
                                title:"TRANSFER SAGE ORDER",
                                text:message,
                                btnYes:"Transfer",
                                btnNo:"Cancel",
                                action:{
                                    code:PAGE_NAME+'=SUBMIT-SAGE-TRANSFER-ORDER', 
                                    data:new_order,
                                    show_response:true
                                }
                            })
                            
                        } 
                    } 

                     
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_SUBMIT_SAGE_TRANSFER_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
            }, 
            SUBMIT_SAGE_TRANSFER_ORDER(order,action){
                try {  
                        console.log(order,'order..............');
                        this.inputLoading = true 
                        this.MBS.actions.progressDialog({
                            show:true,
                            fixed:false,
                            title:"Updating"
                        }) 
                        this.MBS.actions.POST_REQUEST({
                            action:this.VALUE_ITEM,
                            path:"processInventory",
                            data:order,
                            us:this.us
                        }) 
                        .then(res=>{  
                            this.MBS.actions.progressDialog()  
                            const body = res?.body
                            const mra_response =  body?.mra_response
                            const failedCount =  mra_response?.failedCount
                            const successCount =  mra_response?.successCount
                            const errors =  mra_response?.errors
                            let error_message = "\n\n EIS ERRORS"
                            errors?.forEach((err,index) => {
                                error_message = error_message+ `\n
                                ${index+1}. ${err.barcode} = ${err.error}`
                            });

                            let mbs_text = this.MBS.text.item_action_success("SAGE ORDER","PROCESS")
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:`${mbs_text.text} \n Success = ${successCount} \n Failed = ${failedCount} ${failedCount>0?error_message:''}`,
                                btnYes:mbs_text.btnYes, 
                            })   
                            console.log(res,'re..................s');
                            let process_orders = {}
                            process_orders[order.docNum] = order
                            this.ON_PROCESS_SAGE_TRANSFERS({
                                status:"Printed",
                                orders:process_orders,
                                notify:false,
                                confirm:false
                            })
                        }).catch(error=>{
                            console.log(error,'err..................');
                            const error_body = error?.error?.body || null
                            const error_message = error_body.message? error_body.message : error_body?.error 
                            const error_remark = error?.error?.body?.error?.remark

                            console.log(error_body,'error_body......');
                            console.log(error_message,'error_message......');
                            console.log(error_remark,'error_remark......');
                            
                            this.MBS.actions.progressDialog()  
                            this.inputLoading = false 
                            let mbs_text = this.MBS.text.item_action_fail(`
                                SAGE ORDER (${error_remark?error_remark:error_message})`,"PROCESSING")
                            this.MBS.actions.dialog({
                                show:true,
                                fixed:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes, 
                            }) 
                            if (error_message == "Order exist") {
                                let process_orders = {}
                                process_orders[order.docNum] = order
                                this.ON_PROCESS_SAGE_TRANSFERS({
                                    status:"Printed",
                                    orders:process_orders,
                                    notify:false,
                                    confirm:false
                                })
                            }
                        })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_SAGE_TRANSFER_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            ON_PROCESS_SAGE_TRANSFER(payload,){  
                const server = this.CurrentServer
                const link = server?.api_link
                const status = payload?.status || "Printed"
                const notify = payload?.notify  
                const confirm = payload?.confirm  
                const action = payload?.action  
                const process_orders =   payload?.order || {}
                 
                const upload_data = {
                    ...process_orders,
                    status,
                    notify,
                    lan:link,
                } 
               
                console.log(payload,'payload------------------'); 
                console.log(upload_data,'upload_data------------------'); 

                if (confirm) {
                    let mbs_text = this.MBS.text.item_action(DATA.ITEMS.SAGE_TRANSFERS.name,action || "Process")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                        action:{
                            code:PAGE_NAME+"=PROCESS-SAGE-TRANSFER",
                            data:upload_data
                        }
                    }) 
                }else{
                    this.PROCESS_SAGE_TRANSFER(upload_data)
                }
            
            },
            PROCESS_SAGE_TRANSFER(payload){  
                console.log(payload,'ON_PROCESS_SAGE_TRANSFER------------------'); 
                this.MBS.actions.progressDialog({
                    show:true,
                    fixed:false,
                    title:"Processing..."
                }) 
                this.MBS.networkEvents.UPDATE_SAGE_TRANSFER(payload)
                .then(res=>{
                    console.log(res,'res..................yy');   
                    this.MBS.actions.progressDialog() 
                    let mbs_text = this.MBS.text.item_action_success("SAGE ORDER","PROCESSING")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:`${mbs_text.text}`,
                        btnYes:mbs_text.btnYes, 
                    }) 
                }).catch(error=>{
                    console.log(error,'err..................yy'); 
                    this.MBS.actions.progressDialog() 
                    let mbs_text = this.MBS.text.item_action_fail("SAGE ORDER","PROCESSING")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:`${mbs_text.text}`,
                        btnYes:mbs_text.btnYes, 
                    }) 
                })
            
            },
            ON_PROCESS_SAGE_TRANSFERS(payload,){  
                const status = payload?.status || "Printed"
                const notify = payload?.notify  
                const confirm = payload?.confirm  
                const orders = payload?.orders?Object.values(payload?.orders).filter(order=>order):null  
                const selected_orders = this.SELECTED_SAGE_TRANSFERS?Object.values(this.SELECTED_SAGE_TRANSFERS).filter(order=>order):null
                const process_orders = orders || selected_orders 
                const updating_orders = []
                if (process_orders) {
                    for(let i = 0; i < process_orders.length; i++) {
                        const order = process_orders[i];
                        updating_orders.push({
                            docNum:order?.docNum,
                            status:status 
                        })
                    }
                } 
                const upload_data = {
                    orders:{items:updating_orders},
                    lan:this.SageLoader?.lan,
                    notify,
                } 
               
                console.log(payload,'payload------------------'); 
                console.log(upload_data,'upload_data------------------'); 

                if (confirm) {
                    let mbs_text = this.MBS.text.item_action(DATA.ITEMS.SAGE_INVOICES.name,"Process")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                        action:{
                            code:PAGE_NAME+"=PROCESS-SAGE-INVOICE",
                            data:upload_data
                        }
                    }) 
                }else{
                    this.PROCESS_SAGE_TRANSFERS(upload_data)
                }
            
            },
            PROCESS_SAGE_TRANSFERS(payload){  
                console.log(payload,'ON_PROCESS_SAGE_TRANSFERS------------------'); 
                this.MBS.events.UPDATE_SAGE_TRANSFERS(payload).then(res=>{
                    console.log(res,'res..................yy');   
                }).catch(error=>{
                    console.log(error,'err..................yy'); 
                })
            
            },
            ON_SELECT_SAGE_ALL_TRANSFERS(input) {
                try {
                    this.SELECTED_SAGE_TRANSFERS = {}
                    if (input) {
                        const transfers = this.SageTransferOrdersSearch
                        transfers?.forEach(transfer => { 
                            this.$set(this.SELECTED_SAGE_TRANSFERS, [transfer?.docNum], transfer); 
                        });  
                    }  
                } catch (error) {
                    this.MBS.actions.error({
                    error: error,
                    from: 'ON_SELECT_SAGE_ALL_TRANSFERS',
                    page: PAGE_NAME, 
                    });
                }
            },
            ON_SELECT_SAGE_TRANSFER_ORDER(transfer) {
                try { 
                    const selected_invoice = this.SELECTED_SAGE_TRANSFERS?.[transfer?.docNum]
                    if (selected_invoice) { 
                        this.$set(this.SELECTED_SAGE_TRANSFERS, [transfer?.docNum], null);  
                    } else { 
                        this.$set(this.SELECTED_SAGE_TRANSFERS, [transfer?.docNum], transfer); 
                    }
                    

                } catch (error) {
                    this.MBS.actions.error({
                    error: error,
                    from: 'ON_SELECT_SAGE_TRANSFER_ORDER',
                    page: PAGE_NAME, 
                    });
                }
            },
            
            CONFIRM_CLEAR_SELECTED_ITEMS(){
                try {   
                    let mbs_text = this.MBS.text.item_action("Selected Items","Clear") 
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-delete",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=CLEAR-SELECTED-ITEMS', 
                            show_response:true
                        }
                    })   
                      
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CLEAR_SELECTED_ITEMS(show_response){
                try {   
                    DB.deleteItems({
                        name:DATA.ITEMS.LOCAL_SELECTED_STOCK_ADJUSTMENTS.values, 
                        update_locals:true, 
                    }).then(res=>{
                        console.log(res,'res........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_success("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            })     
                        }
                    }).catch(error=>{
                        console.log(error,'error...........');
                        this.MBS.actions.progressDialog()
                        if (show_response) {
                            let mbs_text = this.MBS.text.item_action_fail("Selected Items","Clearing")
                            this.MBS.actions.dialog({
                                show:true,
                                title:mbs_text.title,
                                text:mbs_text.text,
                                btnYes:mbs_text.btnYes,
                                btnNo:mbs_text.btnNo, 
                            }) 
                        }
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_CLEAR_SELECTED_ITEMS',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CONTINUE_STOCK_TRANSFER(){
                try {  
                    this.input.from_outlet_code = this.stock_outlet_code? this.stock_outlet_code:null,
                    this.input.selected_items = this.selected_items? this.selected_items:null
                    this.dialog_transfer_select_items = false
                    this.dialog_transfer_stocks = true  
                    // setTimeout(() => {
                    // }, 100);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONTINUE_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            BACK_STOCK_TRANSFER(){
                try {   
                    this.dialog_transfer_select_items = true
                    this.dialog_transfer_stocks = false   
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'BACK_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_SOCK_TRANSFER(option){ 
                try { 
                    this.menu_transfer_option = false
                    this.transfer_option = option 
                    this.$refs.ref_btn_transfer_stock.$el.click();
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SEND_AND_PRINT_NEW_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
            },
            CONFIRM_STOCK_TRANSFER(input,transfer_option){
                try {    
                    const ud = this.ud
                    const uid = ud?.uid
                    const company = this.selectedCompany
                    const company_key = company?.company_key
                    const moment = this.MBS.date.moment
                    const key = moment?moment().valueOf():null
                    const code = input?.code?input?.code:null
                    const from_outlet_code = input?.from_outlet_code?input?.from_outlet_code:null
                    const to_outlet_code = input?.to_outlet_code?input?.to_outlet_code:null
                    const transferred_date = input?.transferred_date?input?.transferred_date:null
                    const description = input?.description?input?.description:null
                    const selected_items = input?.selected_items?input?.selected_items:null
                    let dialog = this.MBS.actions.dialog
                    let items = []
                    let mbs_text = null
                    let error_text = null
                    selected_items?.forEach(item => {
                        items.push({
                            item_key:item._key,
                            item_code:item._code,
                            item_name:item.name,
                            item_cost_price:item.cost_price,
                            quantity:item.quantity, 
                            
                        })
                        
                    });
                    const data = {
                        order_type:DATA.ITEMS.STOCK_TRANSFERS.value,
                        code,from_outlet_code,
                        to_outlet_code,transferred_date,
                        description,items,
                        created_uid:uid,
                        company_key,
                        local_created_at:key,
                        transfer_option
                    }
                    if (from_outlet_code == to_outlet_code) {
                        error_text = 'Transfer to outlet should be different from Transfer from outlet. '
                    }

                    if (transfer_option == "send_for_approval") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Transfer for approval","Send") 
                    }else if (transfer_option == "direct_transfer") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock","Direct Transfer") 
                    }else if (transfer_option == "send_for_verification") {
                        dialog = this.MBS.actions.dialogConfirmPassword
                        mbs_text = this.MBS.text.item_action("Stock Transfer for verification","send") 
                    }else if (transfer_option == "save_draft") {
                        mbs_text = this.MBS.text.item_action("Draft","Save") 
                    }else{
                        error_text = "Something went wrong. Please try again."
                    } 

                    if (error_text) {
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            icon:"mdi-alert",
                            title:"ERROR",
                            text:error_text,
                            btnYes:"OKAY", 
                        })  
                        return 
                    }

                    console.log(input,'input..............');
                    console.log(data,'data..............XXX');
 
                    dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-transfer",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=SUBMIT-TRANSFER-STOCK', 
                            data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"option",  
                                action_name:"Start Stock Take"  
                            }
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_STOCK_TRANSFER',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            SUBMIT_TRANSFER_ORDER(order,action){
                try {  
                    const order_code = order?.code
                    const uid = action?.ud?.uid
                    const transfer_option = order?.transfer_option 
                    let path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_drafts+order_code,true) 
                    if (transfer_option =="send_for_approval") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true)
                    }if (transfer_option =="send_for_verification") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_requests+order_code,true)
                    }if (transfer_option =="direct_transfer") {
                        path = this.MBS.actions.COMPANY_LINK(DATA.PATHS.stock_orders+order_code,true)
                    }
                    if (uid) {
                        order.logged_uid = order.created_uid
                        order.created_uid = uid
                    }
                    if (!order_code || !path) {
                        console.log(order,'order error');
                    } 
                     console.log(path,'path------------**');
                     console.log(action,'action------------**');
                     console.log(order,'order------------**');
                     
                    this.inputLoading = true
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Uploading..",
                    }) 
                    this.$store.dispatch("fi_update",{
                        action:DATA.ITEMS.STOCK_ORDERS.values,
                        data:order,
                        path:path
                    })
                    .then(res=>{
                        console.log(res,'re..................');
                        return  this.$store.dispatch('fi_tracker',{
                            company:this.selectedCompany,
                            names:[
                                {data_save:false,on:false,get:false,cash:true,name:DATA.ITEMS.ITEMS.values}, 
                            ]
                        }) 
                    })
                    .then(res=>{
                        this.inputLoading = false
                        this.dialog_transfer_select_items = false
                        this.dialog_transfer_stocks = false
                        this.MBS.actions.progressDialog() 
                        this.CLEAR_SELECTED_ITEMS()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.STOCKS.value,"Transferring")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })   
                        console.log(res,'re..................s');
                         
                    }).catch(error=>{
                        console.log(error,'err..................');
                        this.MBS.actions.progressDialog() 
                        this.MBS.actions.error({
                            error:error,
                            from:'SUBMIT_ORDER',
                            page:PAGE_NAME, 
                        })  
                        this.inputLoading = false
                        this.MBS.actions.progressDialog() 
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.STOCKS.value,"Transferring")
                        this.MBS.actions.dialog({
                            show:true,
                            fixed:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes, 
                        })  
                    }) 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_TRANSFER_ORDER',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            

            
            CREATE_ITEM(input){
                try {     
                    this.ADDING_ITEM = {...DATA.ITEMS.ITEMS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.items
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Create',
                        action_doing:'Creating'
                    }
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.ITEMS.name,
                            action:"add_item",
                            input:{name:input}
                        }) 
                        console.log(this.ADDING_ITEM,'create item,,,......'); 
                    }, 50);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_ITEM',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            CREATE_ITEM_KIT(input){
                try {     
                    this.ADDING_ITEM = {...DATA.ITEMS.ITEMS}
                    this.ADDING_ITEM.path =  this.MBS.actions.COMPANY_LINK(DATA.PATHS.items,true)
                    this.ADDING_ITEM.fields =  DATA.FIELDS.items_kit
                    this.ADDING_ITEM.add_item_action =  {
                        action_do:'Create',
                        action_doing:'Creating'
                    }
                    setTimeout(() => {
                        this.MBS.events.$emit("ITEM_ACTION",{
                            NAME_ITEM:DATA.ITEMS.ITEMS.name,
                            action:"add_item",
                            input:{name:input}
                        }) 
                        console.log(this.ADDING_ITEM,'create item,,,......'); 
                    }, 50);
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CREATE_ITEM_KIT',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            ADDED(res){
                try { 
                    this.RELOAD_ITEMS()
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ADDED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            RELOAD_ITEMS(){
                try {
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"Refresh..."
                    })
                    this.$store.dispatch('fi_get_item',{
                        name:DATA.ITEMS.ITEMS.values,
                        on:false, 
                        cash:true, 
                        get:false, 
                        company_key:company_key, 
                    }).then(res=>{
                        console.log(res,'res.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_success(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    }).catch(error=>{
                        console.log(error,'error.......');
                        this.MBS.actions.progressDialog()
                        let mbs_text = this.MBS.text.item_action_fail(DATA.ITEMS.ITEMS.values,"Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                    })
                } catch (error) {
                    
                }

            },
            async APPLY_DAYSHIFTS(data,notify){
                try {
                    this.day_shift_data = data
                    console.log(data,'APPLY_DAYSHIFTS........');
                    const dayshifts_keys = data?.dayshifts_keys
                    const selected_dayshifts_keys = data?.selected_dayshifts_keys
                    const search_keys = this.MBS.actions.SIZE(selected_dayshifts_keys)?
                        selected_dayshifts_keys:dayshifts_keys
                     
                    console.log(search_keys,'search_keys.....');
                    
                    let company = this.SelectedCompany
                    let company_key = company?company.company_key:null
                    this.MBS.actions.progressDialog({
                        show:true,
                        text:"getting..."
                    })
                    const res = await this.$store.dispatch('http_get_item',{
                        name:DATA.ITEMS.DAYS_SHIFTS_SALES.values,
                        company_key:company_key,
                        path:"getDayShiftsSales", 
                        data: {
                            company_key:company_key,
                            day_shifts_keys:search_keys
                        }
                    })
                    
                    this.MBS.actions.progressDialog()
                    if (notify) {
                        let mbs_text = this.MBS.text.item_action_success("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    }
                    console.log(res,'res..............'); 
                   
                } catch (error) {
                    console.log(error,'error.......');
                    this.MBS.actions.progressDialog()
                    if (notify) {
                        let mbs_text = this.MBS.text.item_action_fail("Sales Transactions","Refresh")
                        this.MBS.actions.dialog({
                            show:true,
                            title:mbs_text.title,
                            text:mbs_text.text,
                            btnYes:mbs_text.btnYes,
                            btnNo:mbs_text.btnNo, 
                        })
                        
                    }
                    
                }

            },
            SHOW_DIALOG_DOCUMENT(payload){
                try {
                    let data = {}
                    let doc_type = payload?.doc_type
                    let doc_title = payload?.doc_title
                    if(payload?.data){
                        data = payload?.data
                    }
                    if(payload?.key){
                        data.key = payload?.key
                    }
                    if(!this.input_show_doc){
                        this.input_show_doc = {}
                    } 
                    if(data=={}){return null}
                    if (doc_type) {
                        console.log(doc_type,'doc_type/.................');
                    }

                    this.input_show_doc.data = {...data,merge_doc_type:"receipt"}
                    this.input_show_doc.data_key = data.key
                    this.input_show_doc.title = doc_title
                    this.input_show_doc.document_type = doc_type?doc_type:"invoice"
                    this.dialog_doc_show = true  
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'SHOW_DIALOG_DOCUMENT',
                        page:PAGE_NAME, 
                    }) 
                }

            },

            ON_FLAG_IN_TRANSIT(order){
                try {    

                    const data = {
                        order_type:order?.order_type,
                        request_order:order,
                        flag:"in_transit"
                    }
                    console.log(data,"data.....");
                    
                    let mbs_text = this.MBS.text.item_action("In-transit","Flag") 
                    this.MBS.actions.dialogConfirmPassword({
                        show:true,
                        fixed:true,
                        icon:"mdi-truck-delivery",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=FLAG-DELIVERED', 
                            data:data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"option",  
                                action_name:"Start Stock Take"  
                            }
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_FLAG_IN_TRANSIT',
                        page:PAGE_NAME, 
                    }) 
                } 
            }, 
            ON_FLAG_DELIVERED(order){
                try {   
                    const data = {
                        order_type:order?.order_type,
                        request_order:order,
                        flag:"delivered"
                    } 
                     console.log(data,"data.....");
                    let mbs_text = this.MBS.text.item_action("Delivered","Flag") 
                    this.MBS.actions.dialogConfirmPassword({
                        show:true,
                        fixed:true,
                        icon:"mdi-truck-check",
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo,
                        action:{
                            code:PAGE_NAME+'=FLAG-DELIVERED', 
                            data:data,
                            phone_number_start:true,
                            all_users:true,
                            get_access:{
                                permission_type:"option",  
                                action_name:"Start Stock Take"  
                            }
                        }
                    })   
                     
                    
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'ON_FLAG_DELIVERED',
                        page:PAGE_NAME, 
                    }) 
                } 
            },  
            async SUBMIT_FLAG(order,action){
                try {  
                    
                    const SelectedCompany = this.SelectedCompany           
                    const company_key = SelectedCompany?SelectedCompany.company_key:null    
                    let upload_data = {
                        company_key:company_key, 
                        ...order
                    } 
                    const order_types = {
                        sale_order:"flag_sales",
                        stock_transfer:"flag_stock",
                    }
                    this.inputLoading = true
                    this.MBS.actions.progressDialog({
                        show:true,
                        title:"Uploading..",
                    }) 
                    console.log(order?.order_type,"order?.order_type............");
                    console.log(order_types[order?.order_type],"order_types[order?.order_type]............");
                    
                    const flag_res =  await this.MBS.actions.POST_REQUEST({
                        action:this.VALUE_ITEM,
                        path:order_types[order?.order_type],
                        data:upload_data,
                        us:this.us
                    })
                    this.inputLoading = false
                    this.MBS.actions.progressDialog()  
                    console.log(flag_res,'flag_res-----------------------******');   
                    if (this.day_shift_data) {
                        await this.APPLY_DAYSHIFTS(this.day_shift_data) 
                    }
                    this.MBS.actions.progressDialog() 
                    this.CLEAR_SELECTED_ITEMS()
                    let mbs_text = this.MBS.text.item_action_success("Order","Fragging")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes, 
                    })    
                    
                } catch (error) {
                    console.log(error,'err..................');
                    this.inputLoading = false
                    this.MBS.actions.progressDialog()   
                    let mbs_text = this.MBS.text.item_action_fail("Order","Fragging")
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes, 
                    })  
                    this.MBS.actions.error({
                        error:error,
                        from:'SUBMIT_FLAG',
                        page:PAGE_NAME, 
                    }) 
                }
                
            },
            REFRESH_ORDERS(type,name){
                try {  
                    console.log(this.SageLoaders,'SageLoaders......')
                    const server = this.CurrentServer
                    const link = server?.api_link
                    const sage_loader = this.SAGE_LOADER?.[link]?.[type] || {} 
                    let action = "REFRESH_ORDERS"
                    if (type == "sage_invoice") {
                        action = "DOWNLOAD_SAGE_INVOICES"
                    }else if (type == "sage_inventory_transfer") {
                        action = "DOWNLOAD_SAGE_TRANSFERS"
                    }else if (type == "sage_customer") {
                        action = "DOWNLOAD_SAGE_CUSTOMERS"
                    }
                    let mbs_text = this.MBS.text.item_action(name,"Refresh")
                    this.MBS.actions.dialog({
                        show:true,
                        title:mbs_text.title,
                        text:mbs_text.text,
                        btnYes:mbs_text.btnYes,
                        btnNo:mbs_text.btnNo, 
                        action:{
                            code:PAGE_NAME+"="+action,
                            data:{type,name,server,link,sage_loader:{...sage_loader,lan:link}}
                        }
                    })  
                    console.log({type,name,server,link,sage_loader:{...sage_loader,link}},'REFRESH_ORDERS.........');
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'REFRESH_ORDERS',
                        page:PAGE_NAME, 
                    }) 
                } 
            },
            async DOWNLOAD_SAGE_TRANSFERS(payload){ 
                console.log(payload,'------------------'); 
                this.MBS.actions.progressDialog({
                    show:true,
                    title:"Loading...",  
                })
                const res = await this.MBS.networkEvents.DOWNLOAD_SAGE_TRANSFERS(payload?.sage_loader)
                this.MBS.actions.progressDialog()
                console.log(res,"res.......");
            },
            ON_TAB_CHANGED(type){
                const page_tab= this.warehouse_current_page
                const table_tab= this.input?.current_table_tab || 0
                const SalesOrdersData = this.SalesOrdersData

                console.log(page_tab,"--",table_tab,"page_tab.....",type); 
                this.filter_dayshifts = null
                if (table_tab== 0 && page_tab!=3) {
                    this.filter_dayshifts = [this.stock_outlet_code]
                    if(!this.MBS.actions.SIZE(SalesOrdersData)){
                        this.ON_SELECT_DAY_SHIFT()
                    } 
                } 
                if (page_tab>2) {
                    this.filter_dayshifts = null
                }
                
            },

            FULLSCREEN(activate=true){  
                try {     
                    let always_on_fullscreen = true
                    let fullscreen = this.fullscreen
                    if (always_on_fullscreen) {
                        this.MBS.actions.SCREEN_FULL_MODE(true) 
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FULLSCREEN',
                        page:PAGE_NAME, 
                    }) 
                }
                
            }, 

            ON_SELECT_DAY_SHIFT(){ 
                this.MBS.actions.dialog({
                    show:true,
                    fixed:true,
                    title:"SELECT DAY SHIFT",
                    text:"You must select dayshift to access the posted sale order transactions.",
                    btnYes:"SELECT",
                    btnNo:"CANCEL", 
                    action:{
                        code:PAGE_NAME+"=SELECT-DAY-SHIFT"
                    }
                })
            },
            SELECT_DAY_SHIFT(){
                this.MBS.events.$emit("ON_DAYSHIFT_SELECTOR")
            }, 

            //---------------[MAIN FUNCTIONS]------------ 
            DIALOG_YES(action){ 
                try {
                    if (action.code) {
                        if (action.code ===PAGE_NAME+'=RELOAD-ITEMS') {
                            if (action.YES) {
                                this.RELOAD_ITEMS()
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=CLEAR-SELECTED-ITEMS') {
                            if (action.YES) {
                                this.CLEAR_SELECTED_ITEMS(action.show_response)
                            } else {
                                
                            }
                        } if (action.code ===PAGE_NAME+'=SUBMIT-TRANSFER-STOCK') {
                            if (action.YES) {
                                this.SUBMIT_TRANSFER_ORDER(action.data,action)
                            } else {
                                
                            }
                        } 
                        if (action.code ===PAGE_NAME+'=FLAG-IN-TRANSIT') {
                            if (action.YES) {
                                this.SUBMIT_FLAG(action.data,action)
                            } else {
                                
                            }
                        }
                        if (action.code ===PAGE_NAME+'=FLAG-DELIVERED') {
                            if (action.YES) {
                                this.SUBMIT_FLAG(action.data,action)
                            } else {
                                
                            }
                        }if (action.code ===PAGE_NAME+'=SUBMIT-SAGE-TRANSFER-ORDER') {
                            if (action.YES) {
                                this.SUBMIT_SAGE_TRANSFER_ORDER(action.data,action)
                            } else {
                                
                            }
                        }if (action.code ===PAGE_NAME+'=PROCESS-SAGE-TRANSFER') {
                            if (action.YES) {
                                this.PROCESS_SAGE_TRANSFER(action.data,action)
                            } else {
                                
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=DOWNLOAD_SAGE_TRANSFERS') {
                            if (action.YES) {
                                this.DOWNLOAD_SAGE_TRANSFERS(action.data,action)
                            } else {
                                
                            }
                        }
                        if (action.code ===PAGE_NAME+'=TRANSFER_SAGE_ITEMS_NOT_FOUND') {
                            if (action.YES) {
                                this.ON_PROCESS_SAGE_TRANSFER({
                                    status:"Printed",
                                    order:action.data
                                })
                            } else {
                                this.ON_PROCESS_SAGE_TRANSFER({
                                    status:"Deleted",
                                    order:action.data
                                })
                            }
                        }  
                        if (action.code ===PAGE_NAME+'=SELECT-DAY-SHIFT') {
                            if (action.YES) {
                                this.SELECT_DAY_SHIFT()
                            } else {
                                this.MBS.actions.go()
                            }
                        }
                    } 
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME, 
                    }) 
                }  
            },  
            FEEDBACKS(time){ 
                try {
                    if (!time) { time=400 }
                    setTimeout(()=>{
                        let us = this.loggedUser 
                        let ps = this.processes
                        let ld = this.loading
                        let res = this.responses

                        //Check process 
                        if (ps) {
                            let gettingItems = ps.find(process=>{
                                return process.name == 'getting/'+this.VALUE_ITEMS
                            })
                            if (!gettingItems) {
                                this.PAGE_LOAD =true
                            }  
                        }else{
                            this.PAGE_LOAD =true
                        } 
                    },time)
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'FEEDBACKS',
                        page:PAGE_NAME, 
                    })  
                } 
            },  
        },
        beforeDestroy(){
            try { 
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);    
                console.log("beforeDestroy-----------");
            } catch (error) {
                this.MBS.actions?.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME, 
                })
            }
        },
        watch: {  
            search_item(value){ 
                if (value) { 
                    this.ADD_ITEM(value) 
                }
            }, 
            loading(value){
                this.FEEDBACKS(1)
            },
            processes(value){
                this.FEEDBACKS(1)
            },
            responses(value){
                this.FEEDBACKS(1) 
            }, 
            input_transfer(value){
                this.selected_items = value?.selected_items 
            }, 
            warehouse_current_page(value){
                this.ON_TAB_CHANGED("page")
            },
            input(value){
                this.ON_TAB_CHANGED("table")
            }, 
        },
    }
</script>
 
